export default "__VITE_ASSET__L22PWbQY__"